export const isArrayValue = (value: number | [number, number]): value is [number, number] => {
  return Array.isArray(value)
}
